import classNames from "classnames";
import React from "react";
import Game from "../../react-components/game";
import Heading from "../../elements/heading";
import IconLink from "../../elements/icon-link";
import PrimaryButton from "../../elements/primary-button";
import PrimaryLink from "../../elements/primary-link";
import BodyText from "../../elements/body-text";
import "./style.scss";

export default function FourZeroFourGame({ fields, rendering }) {
  const { paddingAboveTop, paddingAboveBottom, headingType, headingBody, body, winMessageDesktop, winMessageMobile, tryAgainMessageDesktop, tryAgainMessageMobile, cta } = fields;

  const game = {
    winMessageDesktop: winMessageDesktop.value,
    winMessageMobile: winMessageMobile.value,
    tryAgainMessageDesktop: tryAgainMessageDesktop.value,
    tryAgainMessageMobile: tryAgainMessageMobile.value
  };
  const getCTA = cta => {
    const type = cta.ctatype.fields.phrase.value;
    if (type === "primary-button") {
      return <PrimaryButton {...cta} />;
    } else if (type === "primary-link") {
      return <PrimaryLink {...cta} />;
    } else {
      // default type
      return <IconLink {...cta} />;
    }
  };

  const componentClasses = classNames("four-o-four-content", "grid", "padding-top-" + paddingAboveTop.fields.phrase.value || "default", "padding-bottom-" + paddingAboveBottom.fields.phrase.value || "default");

  return (
    <div className={componentClasses} datasourceid={rendering.dataSource}>
      <div className={"game-container"}>
        <Game {...game} />
      </div>
      <Heading type={headingType} className={"title"} html={headingBody} typographyClass="type-h1" />

      {body && <BodyText html={body.value} />}
      {cta && <div className={"button-container"}>{getCTA(cta.fields)}</div>}
    </div>
  );
}
